export const GSI_SRC = 'https://accounts.google.com/gsi/client';

let loading: Promise<void> | null = null;

/** Loads the GIS script once; safe to call from several components. */
export function loadGsiScript(): Promise<void> {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (loading) return loading;

  loading = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${GSI_SRC}"]`);
    const script = existing ?? document.createElement('script');
    const fail = () => {
      loading = null;
      reject(new Error('gsi_script_failed'));
    };
    script.addEventListener('load', () => resolve(), { once: true });
    script.addEventListener('error', fail, { once: true });
    if (!existing) {
      script.src = GSI_SRC;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  });
  return loading;
}
